import React from "react";
import Zoom from "react-reveal/LightSpeed";
import { NavLink } from "react-router-dom";

const About = () => {
  const values = [
    {
      icon: "🤝",
      title: "Client First",
      description:
        "We begin by understanding the client's actual requirement and design our services around their business needs."
    },
    {
      icon: "🛡️",
      title: "Trust & Integrity",
      description:
        "We believe long-term business relationships are built through transparency, responsibility and consistent communication."
    },
    {
      icon: "🎯",
      title: "Quality Focus",
      description:
        "We aim to provide capable professionals and reliable services that create meaningful value for our clients."
    },
    {
      icon: "📈",
      title: "Scalable Solutions",
      description:
        "Our engagement models are designed to help businesses start with a specific requirement and scale as their needs grow."
    }
  ];

  const capabilities = [
    {
      icon: "📊",
      title: "Finance & Accounting",
      description:
        "Helping businesses outsource accounting and finance operations through skilled professionals and dedicated teams."
    },
    {
      icon: "👥",
      title: "Staffing & Payroll",
      description:
        "Connecting businesses with professionals through flexible staffing and third-party payroll models."
    },
    {
      icon: "💻",
      title: "IT & Technology",
      description:
        "Supporting businesses with IT professionals, dedicated development resources and practical technology solutions."
    },
    {
      icon: "⚙️",
      title: "Business Process Outsourcing",
      description:
        "Helping organizations outsource selected business processes and operational functions."
    }
  ];

  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        color: "#0f172a",
        backgroundColor: "#ffffff",
        overflowX: "hidden"
      }}
    >
      {/* =========================================================
          HERO SECTION
      ========================================================= */}
      <section
        style={{
          background:
            "linear-gradient(135deg, #07162c 0%, #0b1f3a 55%, #12345b 100%)",
          padding: "95px 20px",
          color: "#ffffff",
          textAlign: "center",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "420px",
            height: "420px",
            borderRadius: "50%",
            backgroundColor: "rgba(59,130,246,0.08)",
            top: "-200px",
            right: "-100px"
          }}
        />

        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            backgroundColor: "rgba(14,165,233,0.06)",
            bottom: "-170px",
            left: "-100px"
          }}
        />

        <div
          className="container"
          style={{
            position: "relative",
            zIndex: 2
          }}
        >
          <Zoom>
            <div
              style={{
                display: "inline-block",
                padding: "8px 16px",
                borderRadius: "50px",
                backgroundColor: "rgba(59,130,246,0.14)",
                border: "1px solid rgba(96,165,250,0.25)",
                color: "#93c5fd",
                fontSize: "12px",
                fontWeight: "800",
                letterSpacing: "1.5px",
                marginBottom: "22px"
              }}
            >
              ABOUT HIMSAL
            </div>

            <h1
              style={{
                fontSize: "clamp(2.4rem, 6vw, 4rem)",
                fontWeight: "800",
                letterSpacing: "-1px",
                lineHeight: "1.1",
                margin: "0 auto 20px",
                maxWidth: "850px",
                color: "#ffffff"
              }}
            >
              Helping Businesses
              <br />
              <span style={{ color: "#60a5fa" }}>
                Build, Operate & Grow
              </span>
            </h1>

            <p
              style={{
                color: "#cbd5e1",
                maxWidth: "720px",
                margin: "0 auto",
                fontSize: "17px",
                lineHeight: "1.8"
              }}
            >
              Himsal Services helps businesses access skilled professionals,
              outsource essential operations and build technology solutions
              through flexible and practical service models.
            </p>
          </Zoom>
        </div>
      </section>

      {/* =========================================================
          WHO WE ARE
      ========================================================= */}
      <section
        style={{
          padding: "95px 20px",
          backgroundColor: "#ffffff"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "1180px",
            margin: "0 auto"
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(300px, 1.1fr) minmax(280px, 0.9fr)",
              gap: "70px",
              alignItems: "center"
            }}
          >
            {/* LEFT */}
            <div>
              <div
                style={{
                  color: "#2563eb",
                  fontSize: "13px",
                  fontWeight: "800",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  marginBottom: "12px"
                }}
              >
                Who We Are
              </div>

              <h2
                style={{
                  color: "#0f172a",
                  fontSize: "clamp(2rem, 4vw, 3rem)",
                  fontWeight: "800",
                  lineHeight: "1.2",
                  margin: "0 0 24px"
                }}
              >
                A Growing Business Services
                <br />
                <span style={{ color: "#2563eb" }}>
                  & Technology Company
                </span>
              </h2>

              <p
                style={{
                  color: "#475569",
                  fontSize: "16px",
                  lineHeight: "1.85",
                  marginBottom: "18px"
                }}
              >
                Himsal Services Private Limited is a business services company
                focused on helping organizations access the people, services
                and technology they need to operate and grow.
              </p>

              <p
                style={{
                  color: "#64748b",
                  fontSize: "15px",
                  lineHeight: "1.85",
                  marginBottom: "18px"
                }}
              >
                Our services bring together Finance & Accounting Outsourcing,
                Professional Staffing, Third-Party Payroll, IT Services,
                Website & Software Development and Business Process
                Outsourcing.
              </p>

              <p
                style={{
                  color: "#64748b",
                  fontSize: "15px",
                  lineHeight: "1.85",
                  margin: 0
                }}
              >
                We believe businesses should be able to access the right
                capabilities without having to build every function completely
                in-house. That is where Himsal aims to create value.
              </p>
            </div>

            {/* RIGHT */}
            <div
              style={{
                background:
                  "linear-gradient(145deg, #f8fafc 0%, #eef5ff 100%)",
                border: "1px solid #e2e8f0",
                borderRadius: "16px",
                padding: "35px"
              }}
            >
              <div
                style={{
                  color: "#2563eb",
                  fontSize: "12px",
                  fontWeight: "800",
                  letterSpacing: "1.5px",
                  marginBottom: "12px"
                }}
              >
                OUR APPROACH
              </div>

              <h3
                style={{
                  color: "#0f172a",
                  fontSize: "24px",
                  fontWeight: "800",
                  margin: "0 0 20px",
                  lineHeight: "1.3"
                }}
              >
                Simple. Flexible. Business-focused.
              </h3>

              {[
                "Understand the requirement",
                "Provide the right people or solution",
                "Create a flexible engagement model",
                "Scale as the business grows"
              ].map((item, index) => (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    padding: "15px 0",
                    borderBottom:
                      index !== 3
                        ? "1px solid #dbe4ef"
                        : "none"
                  }}
                >
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "#dbeafe",
                      color: "#2563eb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "13px",
                      fontWeight: "800",
                      flexShrink: 0
                    }}
                  >
                    {index + 1}
                  </div>

                  <span
                    style={{
                      color: "#334155",
                      fontSize: "14px",
                      fontWeight: "600"
                    }}
                  >
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
          WHAT WE DO
      ========================================================= */}
      <section
        style={{
          padding: "95px 20px",
          backgroundColor: "#f8fafc"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "1180px",
            margin: "0 auto"
          }}
        >
          <div
            style={{
              textAlign: "center",
              maxWidth: "750px",
              margin: "0 auto 55px"
            }}
          >
            <div
              style={{
                color: "#2563eb",
                fontSize: "13px",
                fontWeight: "800",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                marginBottom: "12px"
              }}
            >
              Our Capabilities
            </div>

            <h2
              style={{
                color: "#0f172a",
                fontSize: "clamp(2rem, 4vw, 2.8rem)",
                fontWeight: "800",
                margin: "0 0 18px"
              }}
            >
              What Himsal Does
            </h2>

            <p
              style={{
                color: "#64748b",
                fontSize: "16px",
                lineHeight: "1.8",
                margin: 0
              }}
            >
              Our current capabilities are built around four core areas that
              help businesses manage people, operations and technology.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px"
            }}
          >
            {capabilities.map((item) => (
              <div
                key={item.title}
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "14px",
                  padding: "30px"
                }}
              >
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "10px",
                    backgroundColor: "#eff6ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "25px",
                    marginBottom: "22px"
                  }}
                >
                  {item.icon}
                </div>

                <h3
                  style={{
                    color: "#0f172a",
                    fontSize: "18px",
                    fontWeight: "800",
                    margin: "0 0 12px"
                  }}
                >
                  {item.title}
                </h3>

                <p
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                    lineHeight: "1.75",
                    margin: 0
                  }}
                >
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================================
          MISSION & VISION
      ========================================================= */}
      <section
        style={{
          padding: "95px 20px",
          backgroundColor: "#ffffff"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "1180px",
            margin: "0 auto"
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "25px"
            }}
          >
            {/* MISSION */}
            <div
              style={{
                backgroundColor: "#07162c",
                borderRadius: "16px",
                padding: "40px"
              }}
            >
              <div
                style={{
                  color: "#60a5fa",
                  fontSize: "12px",
                  fontWeight: "800",
                  letterSpacing: "1.5px",
                  marginBottom: "15px"
                }}
              >
                OUR MISSION
              </div>

              <h3
                style={{
                  color: "#ffffff",
                  fontSize: "26px",
                  fontWeight: "800",
                  margin: "0 0 18px"
                }}
              >
                Make Business Growth Easier
              </h3>

              <p
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: "1.85",
                  margin: 0
                }}
              >
                Our mission is to help businesses access reliable
                professionals, outsource important operations and adopt
                practical technology solutions without unnecessary complexity.
              </p>
            </div>

            {/* VISION */}
            <div
              style={{
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                borderRadius: "16px",
                padding: "40px"
              }}
            >
              <div
                style={{
                  color: "#2563eb",
                  fontSize: "12px",
                  fontWeight: "800",
                  letterSpacing: "1.5px",
                  marginBottom: "15px"
                }}
              >
                OUR VISION
              </div>

              <h3
                style={{
                  color: "#0f172a",
                  fontSize: "26px",
                  fontWeight: "800",
                  margin: "0 0 18px"
                }}
              >
                Build a Trusted Business Services Company
              </h3>

              <p
                style={{
                  color: "#64748b",
                  fontSize: "15px",
                  lineHeight: "1.85",
                  margin: 0
                }}
              >
                Our long-term vision is to grow Himsal into a trusted
                professional services company that combines staffing,
                outsourcing, finance and technology capabilities to serve
                businesses across markets.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================
          VALUES
      ========================================================= */}
      <section
        style={{
          padding: "95px 20px",
          backgroundColor: "#f8fafc"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "1180px",
            margin: "0 auto"
          }}
        >
          <div
            style={{
              textAlign: "center",
              maxWidth: "720px",
              margin: "0 auto 55px"
            }}
          >
            <div
              style={{
                color: "#2563eb",
                fontSize: "13px",
                fontWeight: "800",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                marginBottom: "12px"
              }}
            >
              Our Values
            </div>

            <h2
              style={{
                color: "#0f172a",
                fontSize: "clamp(2rem, 4vw, 2.8rem)",
                fontWeight: "800",
                margin: "0 0 18px"
              }}
            >
              How We Work
            </h2>

            <p
              style={{
                color: "#64748b",
                fontSize: "16px",
                lineHeight: "1.8",
                margin: 0
              }}
            >
              The principles we want to build into every client relationship
              and every service we deliver.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px"
            }}
          >
            {values.map((value) => (
              <div
                key={value.title}
                style={{
                  backgroundColor: "#ffffff",
                  padding: "30px",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0"
                }}
              >
                <div
                  style={{
                    fontSize: "28px",
                    marginBottom: "18px"
                  }}
                >
                  {value.icon}
                </div>

                <h3
                  style={{
                    color: "#0f172a",
                    fontSize: "18px",
                    fontWeight: "800",
                    margin: "0 0 10px"
                  }}
                >
                  {value.title}
                </h3>

                <p
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                    lineHeight: "1.75",
                    margin: 0
                  }}
                >
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================================
          FUTURE DIRECTION
      ========================================================= */}
      <section
        style={{
          padding: "95px 20px",
          backgroundColor: "#ffffff"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center"
          }}
        >
          <div
            style={{
              color: "#2563eb",
              fontSize: "13px",
              fontWeight: "800",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              marginBottom: "12px"
            }}
          >
            Looking Ahead
          </div>

          <h2
            style={{
              color: "#0f172a",
              fontSize: "clamp(2rem, 4vw, 2.8rem)",
              fontWeight: "800",
              lineHeight: "1.2",
              margin: "0 0 20px"
            }}
          >
            Growing From a Service Provider
            <br />
            <span style={{ color: "#2563eb" }}>
              Into a Long-Term Business Partner
            </span>
          </h2>

          <p
            style={{
              color: "#64748b",
              fontSize: "16px",
              lineHeight: "1.9",
              margin: "0 auto",
              maxWidth: "760px"
            }}
          >
            We are building Himsal with a long-term perspective. As our
            capabilities grow, our goal is to expand the range of finance,
            staffing, outsourcing and technology services we can provide to
            businesses while maintaining the trust and quality that define our
            client relationships.
          </p>
        </div>
      </section>

      {/* =========================================================
          CTA
      ========================================================= */}
      <section
        style={{
          padding: "0 20px 95px",
          backgroundColor: "#ffffff"
        }}
      >
        <div
          style={{
            maxWidth: "1050px",
            margin: "0 auto",
            background:
              "linear-gradient(135deg, #0b1f3a 0%, #123b68 100%)",
            borderRadius: "18px",
            padding: "65px 30px",
            textAlign: "center"
          }}
        >
          <div
            style={{
              color: "#93c5fd",
              fontSize: "12px",
              fontWeight: "800",
              letterSpacing: "1.5px",
              marginBottom: "15px"
            }}
          >
            LET'S CONNECT
          </div>

          <h2
            style={{
              color: "#ffffff",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: "800",
              margin: "0 0 18px"
            }}
          >
            Let's Talk About Your Requirement
          </h2>

          <p
            style={{
              color: "#cbd5e1",
              maxWidth: "650px",
              margin: "0 auto",
              fontSize: "15px",
              lineHeight: "1.8"
            }}
          >
            Whether you are looking for professionals, payroll support,
            finance outsourcing or a technology solution, we would be happy to
            understand your requirement.
          </p>

          <NavLink
            to="/contact"
            style={{
              display: "inline-block",
              marginTop: "30px",
              backgroundColor: "#ffffff",
              color: "#0b1f3a",
              padding: "15px 30px",
              borderRadius: "8px",
              fontWeight: "800",
              textDecoration: "none"
            }}
          >
            Contact Himsal →
          </NavLink>
        </div>
      </section>
    </div>
  );
};

export default About;
